import widgetTemplate from '../../templates/widgetTemplate.html';
import AudioVideoClient from "../main/AudioVideoClient";
import RTPaaSError from "../main/RTPaaSError";
export default class VideoWindow {

    constructor(context, testerIdentifier) {
        this.context = context;
        this.isProctorWindow = context.isProctor();
        this.testerIdentifier = testerIdentifier;
        this.attachVideoWindow();
    }

    async startCall() {
        let params = {
            testerIdentifier : this.testerIdentifier,
            clientId : this.isProctorWindow ? `PROCTOR_${this.context.clientId}` : this.context.clientId,
            meetingId : this.context.meetingId,
            isAttendeeProctor: this.context.isProctor(),
            localVideoElement : this.localVideoElement,
            remoteVideoElement : this.remoteVideoElement,
            callAnsweredCallback : this.callAnswered.bind(this),
            localMuteAudioCallback : this.setLocalMuteStatus.bind(this),
            remoteMuteAudioCallback : this.toggleRemoteMuteButton.bind(this),
            micId : this.context.getMicId?.(),
            speakerId : this.context.getSpeakerId?.(),
            cameraId : this.context.getCameraId?.(),
            errorCallback : this.errorCallback.bind(this),
            endCallWithErrorCallback : this.context.endCallDueToError.bind(this.context)
        };
        this.audioVideoClient = new AudioVideoClient(params);
        await this.audioVideoClient.startCall();
        this.setAudioIconStatus(false, true);
        if(this.isProctorWindow) {
            this.setVideoIconStatus(false, true);
        }
        return Promise.resolve(true);
    }

    callAnswered() {
        $(`#videoPlayerRemote_${this.testerIdentifier}`).removeClass('rtpIcon-no-display');
        $(`#videoPlayerRemoteTxt_${this.testerIdentifier}`).addClass('rtpIcon-no-display');
    }

    toggleRemoteMuteButton(muted) {
        if(muted) {
            $(`#remoteVideoMute_${this.testerIdentifier}`).removeClass('rtpIcon-no-display');
        } else {
            $(`#remoteVideoMute_${this.testerIdentifier}`).addClass('rtpIcon-no-display');
        }
    }

    errorCallback(type, err) {
        console.error(`${type} error - ${err}`);
        this.context.setVideoStatusText(this.testerIdentifier, rtp_i18next.t("generalWords:connectionError"));
        this.context.endCallDueToError(this.testerIdentifier, rtp_i18next.t(`generalWords:${type}NotAvailable`));
        this.context.sendErrorMessage(`chime call ${type} error - ${err}`,
            (new Error()).stack);
        this.endCall();
        RTPaaSError.triggerRTPError(err);
    }

    async endCall() {
        this.toggleRemoteMuteButton(false);
        this.setAudioIconStatus(false, true);

        if (this.isProctorWindow) {
            this.setVideoIconStatus(false, true);
            let remotePlayerContainer = document.getElementById("videoPlayerRemote_" + this.testerIdentifier);
            let remotePlayerContainerTxt = document.getElementById("videoPlayerRemoteTxt_" + this.testerIdentifier);
            remotePlayerContainer && remotePlayerContainer.classList.add('rtpIcon-no-display');
            remotePlayerContainerTxt && remotePlayerContainerTxt.classList.remove('rtpIcon-no-display');
        }
        await this.audioVideoClient?.endCall();
    }

    attachVideoWindow() {
        let videoDivHTML =  _.template($(widgetTemplate).filter("#videoWindow").html());
        let testerIdentifier = this.testerIdentifier;
        let displayName = this.isProctorWindow ? this.context.getTesterDisplayName(testerIdentifier) : null;
        $(`#callVideoContainer-${testerIdentifier}`).append(videoDivHTML({testerIdentifier, isProctorWindow: this.isProctorWindow, displayName:displayName}));
        this.localVideoElement = document.getElementById("localVideoContent_" + testerIdentifier);
        this.remoteVideoElement = document.getElementById("remoteVideoContent_" + testerIdentifier);
        this.attachListeners();
        this.addTooltips();
    }

    attachListeners(){
        $('.muteAudioBtn').off('click',this.muteAudioBtnClickHandler.bind(this)).on('click',this.muteAudioBtnClickHandler.bind(this));
        $('.muteVideoBtn').off('click',this.muteVideoBtnClickHandler.bind(this)).on('click',this.muteVideoBtnClickHandler.bind(this));
    }

    addTooltips(){
        $k('#muteAudio_'+ this.testerIdentifier).kendoTooltip({content: rtp_i18next.t("generalWords:muteMicrophone")});
        if(this.isProctorWindow){
            $k('#muteVideo_'+ this.testerIdentifier).kendoTooltip({content: rtp_i18next.t("generalWords:turnOffCamera")});
        }
    }

    //TODO: refactor
    setAudioIconStatus(disableIcon, resetIconToDefault) {
        let muteAudioIcon = document.querySelector('#muteAudioIcon_'+ this.testerIdentifier);
        if (muteAudioIcon != undefined && muteAudioIcon != null) {
            muteAudioIcon.classList.remove('rtpIcon-no-display');
            if (resetIconToDefault) {
                muteAudioIcon.classList.remove('rtpIcon-no-display');
                muteAudioIcon.classList.remove('fa-microphone-slash');
                muteAudioIcon.classList.remove('mutedMicrophoneIcon');
                muteAudioIcon.classList.add('fa-microphone');
                muteAudioIcon.classList.add('unMutedMicrophoneIcon');
                this.addMuteBtnTooltip(false);
            }
        }
        let muteAudioBtn = document.querySelector('#muteAudio_'+this.testerIdentifier);
        if (muteAudioBtn != undefined && muteAudioBtn != null) {
            if (disableIcon) {
                muteAudioBtn.disabled = true;
            } else {
                muteAudioBtn.disabled = false;
            }
        }
    }

    //TODO: refactor
    setVideoIconStatus(disableIcon, resetIconToDefault) {
        let muteVideoIcon = document.querySelector('#muteVideoIcon_'+this.testerIdentifier);
        muteVideoIcon.classList.remove('rtpIcon-no-display');
        if (resetIconToDefault) {
            muteVideoIcon.classList.remove('rtpIcon-no-display');
            muteVideoIcon.classList.remove('fa-video-slash');
            muteVideoIcon.classList.remove('mutedVideoIcon');
            muteVideoIcon.classList.add('fa-video');
            muteVideoIcon.classList.add('unMutedVideoIcon');
            this.addVideoBtnTooltip(false);
        }

        let muteVideoBtn = document.querySelector('#muteVideo_'+this.testerIdentifier);
        if (disableIcon) {
            muteVideoBtn.disabled = true;
        } else {
            muteVideoBtn.disabled = false;
        }
    }

    muteAudioBtnClickHandler(e){
        if(this.audioVideoClient.isLocalAudioMuted()) {
            this.unmuteAudio();
        } else {
            this.muteAudio();
        }
    }

    //This is similar to 'muteAudioBtnClickHandler', but its purpose is to sync the button with the current mute status, rather than reverse it.
    setLocalMuteStatus(){
        if(this.audioVideoClient.isLocalAudioMuted()) {
            this.muteAudio();
        } else {
            this.unmuteAudio();
        }
    }

    unmuteAudio() {
        let testerIdentifier = this.testerIdentifier;
        $('#muteAudioIcon_' + testerIdentifier)[0].setAttribute("data-icon", 'microphone');
        $('#muteAudioIcon_' + testerIdentifier)[0].classList.remove('mutedMicrophoneIcon');
        $('#muteAudioIcon_' + testerIdentifier)[0].classList.add('unMutedMicrophoneIcon');
        this.addMuteBtnTooltip(false);
        this.audioVideoClient.unMuteLocalAudio();
    }

    muteAudio() {
        let testerIdentifier = this.testerIdentifier;
        $('#muteAudioIcon_' + testerIdentifier)[0].setAttribute("data-icon", 'microphone-slash');
        $('#muteAudioIcon_' + testerIdentifier)[0].classList.remove('unMutedMicrophoneIcon');
        $('#muteAudioIcon_' + testerIdentifier)[0].classList.add('mutedMicrophoneIcon');
        this.addMuteBtnTooltip(true);
        this.audioVideoClient.muteLocalAudio();
    }

    muteVideoBtnClickHandler(){
        if(this.audioVideoClient.isLocalVideoMuted()) {
            this.unmuteVideo();
            this.audioVideoClient.unMuteLocalVideo();
        } else {
            this.muteVideo();
            this.audioVideoClient.muteLocalVideo();
        }
    }

    unmuteVideo() {
        let testerIdentifier = this.testerIdentifier;
        $('#muteVideoIcon_' + testerIdentifier)[0].setAttribute("data-icon", 'video');
        $('#muteVideoIcon_' + testerIdentifier)[0].classList.remove('mutedVideoIcon');
        $('#muteVideoIcon_' + testerIdentifier)[0].classList.add('unMutedVideoIcon');
        this.addVideoBtnTooltip(false);
    }

    muteVideo() {
        let testerIdentifier = this.testerIdentifier;
        $('#muteVideoIcon_' + testerIdentifier)[0].setAttribute("data-icon", "video-slash");
        $('#muteVideoIcon_' + testerIdentifier)[0].classList.remove('unMutedVideoIcon');
        $('#muteVideoIcon_' + testerIdentifier)[0].classList.add('mutedVideoIcon');
        this.addVideoBtnTooltip(true);
    }

    addMuteBtnTooltip(isMuted){
        let testerIdentifier = this.testerIdentifier;
        $k('#muteAudio_'+testerIdentifier).data("kendoTooltip").destroy();

        if(isMuted){
            $k('#muteAudio_'+testerIdentifier).kendoTooltip({content: rtp_i18next.t("generalWords:unMuteMicrophone")});
        }else{
            $k('#muteAudio_'+testerIdentifier).kendoTooltip({content: rtp_i18next.t("generalWords:muteMicrophone")});
        }
    }

    addVideoBtnTooltip(isCameraOff){
        let testerIdentifier = this.testerIdentifier;
        $k('#muteVideo_'+testerIdentifier).data("kendoTooltip").destroy();

        if(isCameraOff){
            $k('#muteVideo_'+testerIdentifier).kendoTooltip({position: "right" , content: rtp_i18next.t("generalWords:turnOnCamera")});
        }else{
            $k('#muteVideo_'+testerIdentifier).kendoTooltip({position: "right" , content: rtp_i18next.t("generalWords:turnOffCamera")});
        }
    }
}
